const getters = {
    getErrors: state => state.errors
}




export default getters;
